







































































































































































import { Component, Vue, Watch, Prop, Mixins } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import { enumData } from '@/decorators';
import MixinSignBody from '@/mixins/signBody';
import $enum from '@/enumDataMap';
import { namespace } from 'vuex-class';
const User = namespace('user');

@Component({
  components: {
  },
})
export default class AddSubject extends Mixins(MixinSignBody) {
  protected get showRegisterCountryList(): TypeCommon.RegisterCountryItem[] {
    if (!this.isLimitArea) {
      return this.registerCountryList;
    }
    return this.registerCountryList.filter((item: TypeCommon.RegisterCountryItem) => {
      if (this.data.selected_region === 'mainland') {
        return item.country_code === this.$enum.mine.RegisterAreaCodeEnum.CN;
      } else {
        return item.country_code !== this.$enum.mine.RegisterAreaCodeEnum.CN;
      }
    });
  }
  @Prop({ type: Object, default() { return {}; } })
  protected data!: TypeCertification.CustomerStartupInfo;
  @Prop({ type: Boolean, default: false })
  protected isLimitArea!: boolean;
  /** 用户信息 */
  @User.State('userInfo') private userInfo!: TypeUserCenter.UserData;
  /** 签约业务枚举 */
  @enumData('Customer/SignBusinessTypeEnum', [$enum.mine.ContractTypeEnum.OVERSEA_LOCATION, $enum.mine.ContractTypeEnum.TRANSIT_LOCATION, $enum.mine.ContractTypeEnum.TRANSPORT])
  private signBusinessTypeEnum: TypeBase.EnumListItem[] = [];
  /**
   * @description: 提交保存
   * @return {*}
   */
  public submit(callback: (formData?: TypeCertification.SignBodyInfo) => void, cancelCallback?: (formData?: TypeCertification.SignBodyInfo) => void): void {
    const formDataRef = this.$refs.formDataRef as FormModel;
    formDataRef.validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      const formData = this.$util.deepCopy(this.formData);
      // 状态为审核不通过时不提交客户代码
      if (this.formData.sign_body_status === this.$enum.mine.SignBodyStatusEnum.AUDIT_NOT_PASS) {
        // delete formData.account_code;
      }
      const data = await this.saveFirmInfo(formData);
      const h = this.$createElement;
      if (data) {
        this.formData.account_code = data.account_code;
        this.formData.sign_body_status = data.sign_body_status;
        typeof callback === 'function' && callback(formData);
        if (this.formData.register_area_code !== this.$enum.mine.RegisterAreaCodeEnum.CN) {
          this.$confirm({
            title: this.t('提交确认'),
            okText: this.t('提交审核'),
            content: (
              <div>
                <p class='m-0'>{this.t('主体信息提交审核后不可修改，请确保主体信息填写正确。')}</p>
                <p>{this.t('确认提交审核?')}</p>
              </div>
            ),
            onOk: async () => {
              const auditData = await this.submitAudit({
                account_code: this.formData.account_code as string,
              });
              if (auditData) {
                this.formData.sign_body_status = auditData.sign_body_status;
                this.$emit('submit', {
                  sign_body_info: this.formData,
                  status: this.$enum.mine.CustomerStartupStatusEnum.AUDIT_PENDING,
                });
              }
            },
            onCancel: () => {
              typeof cancelCallback === 'function' && cancelCallback();
            },
          });
        }
      }
    });
  }
  /**
   * @description: 按照签约业务新增主体
   * @return {*}
   */

  public addFirm(callback?: (data: TypeCertification.SignBodyInfo) => void): void {
    const formDataRef = this.$refs.formDataRef as FormModel;
    formDataRef.validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      const formData = this.$util.deepCopy(this.formData);
      await this.addFirmInfo(formData);
      typeof callback === 'function' && callback(formData);
    });
  }
  @Watch('data', { immediate: true })
  protected onDataChange(data: TypeCertification.CustomerStartupInfo): void {
    if (data.sign_body_info) {
      const formData = this.$util.deepCopy(data.sign_body_info);
      if (data.selected_region === this.$enum.mine.SelectedRegion.NoMainland && formData.register_area_code === this.$enum.mine.RegisterAreaCodeEnum.CN) {
        formData.register_area_code = '';
        formData.province_code = '';
      } else if (data.selected_region === this.$enum.mine.SelectedRegion.Mainland && formData.register_area_code !== this.$enum.mine.RegisterAreaCodeEnum.CN) {
        formData.register_area_code = this.$enum.mine.RegisterAreaCodeEnum.CN;
      }

      this.formData = data.sign_body_info.account_code === '' ? this.addBaseInfo(formData) : formData;
      this.getRegionList();
    } else {
      this.formData = this.addBaseInfo(this.initFormData());
      this.getRegionList();
    }
  }
  protected handleReturn(): void {
    this.$emit('submit', {
      status: 'select_region',
    });
  }
  /**
   * @description: 添加基本信息，例如：联系人名称、联系人电话、邮箱等
   * @param {*} data 原有数据
   * @return {*}
   */
  private addBaseInfo(data: TypeCertification.SignBodyInfo) {
    return Object.assign(data, {
      contact_name: this.userInfo.contact,
      email: this.userInfo.email,
      phone_number: this.userInfo.phone_no,
      postcode: '',
    });
  }
  /**
   * @description: 添加多个主体信息
   * @param {*} data
   * @return {*}
   */
  private async addFirmInfo(data: TypeCertification.SignBodyInfo) {
    const res = await this.$api.certification.addFirmInfo(data);
    return res.data;
  }
  private created(): void {
    this.queryRegisterCountryList();
  }
}
